"use-strict";

function arrayRemove(arr, value) {
    return arr.filter(function (ele) {
        return ele !== value;
    });
}

function getFallbackAndNotFound(imgTag, fallback, notFound) {
    imgTag.src = fallback;
    if (notFound)
        imgTag.onerror = function() { imgTag.src = notFound; };
}

//Works with the local date time taghelper
function populateDateTimes() {
    const nodes = document.getElementsByClassName("localdatetimeoffset");
    for (let i in nodes) {
        if (Object.prototype.hasOwnProperty.call(nodes, i)) {
            const node = nodes[i];
            const dt = new Date(node.getAttribute("data-datetimeoffset").toString());
            node.innerHTML = dt.toString();
        }
    }
}



$('li a.mobile-navbar-toggle').on("click", function (e) {
    console.log("MOUSIEEEE");
    const thisItem = $(this);
    if (!thisItem.next().hasClass("show")) {
        thisItem.parents(".dropdown-menu").first().find(".show").removeClass("show");
    }
    const subMenu = thisItem.next();
    subMenu.toggleClass("show");
    thisItem.toggleClass("submenu-down");
    

    function removeDropToggle(event) {
        console.log("HIDEME");
        event.stopImmediatePropagation();
        $(".dropdown-submenu .show").removeClass('show');
        thisItem.removeClass("submenu-down")
        thisItem.parents("li.nav-item.dropdown.show").off("hidden.bs.dropdown", removeDropToggle);
    }

    thisItem.parents("li.nav-item.dropdown.show").on("hidden.bs.dropdown", removeDropToggle);
    return false;
});

window.addEventListener("load", populateDateTimes);